import { useState } from "react";
import styles from "../campain.module.css";
import "./sty.scss";
import makeAnimated from "react-select/animated";
import InsertAcordion from "./InsertAcordion";
import Select from "react-select";
function AddCampain({ customers, Update }) {
  const animatedComponents = makeAnimated();
  const [inputFields, setInputFields] = useState([{ nameField: "" }]);
  const allStep = [
    "اول",
    "دوم",
    "سوم",
    "چهارم",
    "پنجم",
    "ششم",
    "هفتم",
    "هشتم",
    "نهم",
    "دهم",
  ];
  const handleChangeInput = (index, event) => {
    const values = [...inputFields];
    values[index][event.target.name] = event.target.value;
    setInputFields(values);
  };
  const handleAddFields = () => {
    setInputFields([...inputFields, { nameField: "" }]);
  };
  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
  };
  return (
    <>
      <div
        class="modal fade"
        id={`exampleModalAdd`}
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        dir="rtl"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header ">
              <h5 className="modal-title" id="edit-userLabel">
                اضافه کردن سرنخ
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="edit-user-container">
                <form id="edit-user-form-data" className="add-container">
                  <div className="d-flex justify-content-between">
                    <p className="mt-2 w-50 textsmall">انتخاب کمپین</p>
                    <Select
                      className="inputModal2"
                      // value={customers[index].barchasb}
                      // onChange={changeHandlerDaste}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti={true}

                      // options={optionDasteBandi}
                    />
                  </div>
                  <div className="d-flex justify-content-between">
                    <p className="mt-2 w-50 textsmall"> اطلاعات مشتری</p>
                    <Select
                      className="inputModal2"
                      // value={customers[index].barchasb}
                      // onChange={changeHandlerDaste}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti={true}

                      // options={optionDasteBandi}
                    />
                  </div>

                  <div className="d-flex justify-content-between ">
                    <p className="textDateBox textsmall"> توضیحات </p>
                    <textarea className={styles.inputModal} type="text" />
                  </div>
                  <div className="d-flex justify-content-between">
                    <p className="mt-2 w-50 textsmall"> مراحل پیگیری</p>
                    <div className={styles.s}>
                      <p></p>
                    </div>
                  </div>
                  <InsertAcordion />
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  Update(customers);
                }}
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddCampain;
{
  /* <input
type="text"
className="form-control"
value={customers[index].status}
onChange={(e) =>
  EditUser((prev) => {
    let temp = [...prev];
    temp[index][e.target.name] = e.target.value;
    return [...temp];
  })
}
name="status"
id="address-edit-user"
/>
</div> */
}
